import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { ComponentLockRule } from "../../helpers/commonStatusHelpers";
import { getGameInformationFormUrl } from "../../helpers/navigationHelpers";
import { useString } from "../../localization/localizationHelpers";
import { Forms, Programs } from "../../models/programsConfig";
import { IdXboxApplicationStep, NdaStatus } from "../../models/status";
import { getNdaStatus } from "../../redux/selectors";
import { FormSummary } from "../FormSummary";

interface FormGameInformationProps {
  statusMessage?: string;
}

export const FormGameInformation = ({ statusMessage }: FormGameInformationProps) => {
  const idXboxGameInformationUnlockRule: ComponentLockRule = useMemo(
    () => ({
      program: Programs.IdXbox,
      step: IdXboxApplicationStep.GameInformation,
    }),
    []
  );
  const ndaStatus = useSelector(getNdaStatus);
  const signNdaToUnlock = useString("signNdaToUnlock");

  return (
    <FormSummary
      formName={Forms.GameInformation}
      getFormUrl={getGameInformationFormUrl}
      unlockRule={idXboxGameInformationUnlockRule}
      lockRightSideText={ndaStatus !== NdaStatus.Signed ? signNdaToUnlock : undefined}
      statusMessage={statusMessage}
    />
  );
};
